import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageShell from '../../components/PageShell';
import Tabs from '../../components/Tabs';
import { resolveTabs } from '../../i18n/resolveTabs';
import ChargesSocialesPage from '../ChargesSocialesPage';
import SocialPhasingTab from '../treasury/tabs/SocialPhasingTab';
import LppPage from './LppPage';

/* Paramètres (ex-« Charges sociales », élargie le 2026-08-21 au soir) — les
   RÈGLES que le module applique, par opposition aux données saisies :
     • Charges sociales  — taux et assiettes par personne
     • LPP               — plan de prévoyance
     • Autres paramètres (venu de l'ex-section « Contrats ») — 13e/14e salaire
   Le Calendrier n'y aura passé qu'une journée : il est parti fonder la
   section « Temps » avec le Temps ouvert — c'est une donnée d'entrée
   du calcul, pas une règle. Le dirigeant vient ici régler COMMENT ça se
   calcule, pas y saisir quelqu'un.
   Gabarit unique : <PageShell framed> + <Tabs> + sous-pages en mode embedded. */
/* Les trois onglets de réglage analytique (groupes ressources, affectations)
   y ont passé une journée, le 2026-08-22 : ils sont repartis dans la section
   « Coût horaire », dont ils sont les entrées exclusives — on ne quitte pas
   une section pour ajuster ce qu'on vient d'y lire. Restent ici les règles
   TRANSVERSES, celles qu'aucune section ne possède en propre. */
/* QUATRE ONGLETS (demande d'Olivier, 2026-09-27) : la page déroulait ses
   quatre cartes à la suite, on descendait pour trouver l'échéancier. La
   PRÉVOYANCE LPP a sa propre section du menu : elle n'appartient qu'à People,
   quand les taux de charges sociales se lisent aussi dans les Paramètres. */
const TAB_DEFS = [
  { id: 'synthese',  labelKey: 'people:social.tabs.synthese' },
  { id: 'base',      labelKey: 'people:social.tabs.base' },
  { id: 'supp',      labelKey: 'people:social.tabs.supp' },
  { id: 'phasing',   labelKey: 'people:social.tabs.phasing' },
  { id: 'lpp',       labelKey: 'people:social.tabs.lpp' },
  /* (« Autres paramètres » — 13e/14e salaire — est passé dans « Contrats et
     frais » le 2026-08-27 : c'est un réglage du CONTRAT, il se lit à côté de
     ce qu'il chiffre.) */
];

export default function HrSocialHub({ activeTenant, setPage, addToast, year, onYearChange, onTenantUpdated, only = null, embedded = false }) {
  /* `only` RESTREINT les onglets (patron de HrPlanningHub) : les taux de
     charges sociales sont partis dans les Paramètres du client le 2026-09-27,
     plusieurs modules les lisant ; la LPP reste ici, elle est nominative. */
  const { t } = useTranslation();
  const [tab, setTab] = useState(Array.isArray(only) && only.length ? only[0] : 'synthese');
  const TABS = resolveTabs(TAB_DEFS.filter((d) => !Array.isArray(only) || only.includes(d.id)), t);

  const renderTab = (id) => {
    switch (id) {
      case 'synthese':
      case 'base':
      case 'supp':     return <ChargesSocialesPage embedded only={tab} activeTenant={activeTenant} addToast={addToast} year={year} onYearChange={onYearChange} />;
      case 'phasing':  return <SocialPhasingTab tenantId={activeTenant?.id} year={year} addToast={addToast} locked={false} onSaved={() => {}} />;
      case 'lpp':      return <LppPage embedded activeTenant={activeTenant} setPage={setPage} year={year} onYearChange={onYearChange} />;
      default: return null;
    }
  };

  /* `embedded` : rendu SANS gabarit de page (2026-09-27). Dans les Paramètres
     du client, la page porte déjà son titre et le panneau le redit à gauche ;
     un troisième « Paramètres » au-dessus des onglets ne disait rien de plus. */
  /* Une ligne d'onglets à UN seul onglet n'offre aucun choix : elle disparaît,
     et la section se lit comme une page simple (2026-09-27). */
  const body = (<>
    {TABS.length > 1 && <Tabs tabs={TABS} active={tab} onChange={setTab} />}
    <div className="page-shell__panel">{renderTab(tab)}</div>
  </>);
  if (embedded) return body;
  return <PageShell framed title={TABS.length > 1 ? t('people:social.title') : TABS[0].label}>{body}</PageShell>;
}
